export default {

  state: {
    messages : Object
  },

  mutations: {
    setMessages(state, payload) {
      state.messages = payload;
    }
  },

  getters: {
    getMessages(state) {
      return state.messages;
    }
  },

  actions: {
    limparMensagens({ commit }){
      commit('setMessages', Object);
    },
    throwError({ commit }, payload){
      const mensagem = {
        message: '500 Internal Server Error',
        variant: 'danger',
        errors: payload || []
      }
      commit('setMessages', mensagem);
    }
  }

}
